import { immer } from "zustand/middleware/immer";

import { MatchingRequest, MatchingViewType } from "@/types";
import { createStore } from "@/utils";

type MatchingState = {
  isGeoShared: boolean;
  viewType: MatchingViewType;
  request: MatchingRequest;
  meta: {
    currentIndex: number;
  };
};

type MatchingActions = {
  actions: {
    changeRequest: (data: MatchingRequest) => void;
    changeGeoSharing: (sharing: boolean) => void;
    changeMatchingViewType: (viewType: MatchingViewType) => void;
    changeMeta: (data: Partial<MatchingState["meta"]>) => void;
  };
};

const defaultMatchingValues: MatchingState = {
  viewType: "column",
  isGeoShared: false,
  request: {
    showOnlyFreeTonight: false,
    sortBy: "lastSeen",
  },
  meta: {
    currentIndex: 0,
  },
};

const useMatchingStore = createStore<MatchingState & MatchingActions>(
  immer((set) => ({
    ...defaultMatchingValues,
    actions: {
      changeRequest: (data) =>
        set((state) => {
          state.request = { ...state.request, ...data };
        }),
      changeMatchingViewType: (viewType) =>
        set((state) => {
          state.viewType = viewType;
        }),
      changeMeta: (meta) =>
        set((state) => {
          state.meta = { ...state.meta, ...meta };
        }),
      changeGeoSharing: (sharing) =>
        set((state) => {
          state.isGeoShared = sharing;
        }),
    },
  }))
);

export { useMatchingStore };
